/**
 * Single source of truth for site-wide identity, contact and social profiles.
 */

export type SocialLink = {
  label: string;
  href: string;
  // icon key is resolved to an inline SVG in the footer
  icon: "linkedin" | "instagram" | "facebook";
};

export const site = {
  name: "Quto AI",
  domain: "qutoai.com",
  url: "https://qutoai.com",
  // Positioning
  tagline: "AI agents that do the work.",
  positioning: "AI agents agency",
  description:
    "Quto AI builds and runs conversational AI agents that book, qualify and support your customers across voice, WhatsApp, chat and web.",

  // General company contact
  email: "quto.official@gmail.com",
  phone: "9680621321",
  whatsapp: "",

  // Physical address kept clean from general footer per instructions
  address: {
    line1: "",
    line2: "",
    city: "",
    state: "",
    postalCode: "",
    country: "India",
  },

  // Legal entity
  legalEntity: "",
  cin: "",

  // Response-time promise shown near forms
  responseTime: "1 business day",

  // Approved public social accounts
  social: [
    { label: "Instagram", href: "https://www.instagram.com/qutoai", icon: "instagram" },
    { label: "Facebook", href: "https://www.facebook.com/qutoai", icon: "facebook" },
    { label: "LinkedIn", href: "https://www.linkedin.com/company/qutoai", icon: "linkedin" },
  ] as SocialLink[],

  // sameAs mirrors the approved social profile URLs for Organization schema
  sameAs: [
    "https://www.instagram.com/qutoai",
    "https://www.facebook.com/qutoai",
    "https://www.linkedin.com/company/qutoai",
  ] as string[],

  // Founding year for copyright
  foundedYear: 2026,
};

export type Site = typeof site;
